/* Ensure both branded cart checkout links navigate directly to Shopify checkout. */
(() => {
  if (window.__daCheckoutNavigationInstalled) return;
  window.__daCheckoutNavigationInstalled = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-da-direct-checkout]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign('/checkout');
  }, true);
})();
